import React from 'react';
import { BillingManagement } from '../../components/BillingManagement';

export function BillingPage() {
  return <BillingManagement />;
}